import React from "react";
import { Link } from 'react-router-dom';

export const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="d-flex align-items-center flex-wrap flex-md-wrap justify-content-between gap-3">
         

          <img className="logo-image" src="/images/tabolutlogoWHITE.png" alt="logo" />
          <div
            style={{
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 12.6,
              display: "inline-flex",

            }}
          >
            {/* <div>
              <div className="jointext">Join our community</div>
            </div> */}

            <div style={{ display: "flex", background: "#1c1c1c", borderRadius: 12, justifyContent: "center", alignItems: "center", padding: 8, flexDirection: "row", gap: 2.5 }}>
              <div style={{ display: "flex", background: "black", borderRadius: 22.5, width: 45, height: 45, justifyContent: "center", alignItems: "center" }}>
                <a
                  href="https://www.instagram.com/stabolut"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="store-badge"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    fill="#fff"
                  >
                    <path
                      d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                    />
                  </svg>
                </a>

              </div>





              <div style={{ display: "flex", background: "black", borderRadius: 22.5, width: 45, height: 45, justifyContent: "center", alignItems: "center" }}>
                <a
                  href="https://t.me/stabolutnews"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="store-badge"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    fill="white"
                  >
                    <path
                      d="M21.643 2.937a1.5 1.5 0 0 0-1.566-.206L2.779 10.144a1.5 1.5 0 0 0 .162 2.796l4.413 1.482 2.235 4.674a1.5 1.5 0 0 0 2.502.289l2.22-2.672 3.978 3.089a1.5 1.5 0 0 0 2.365-1.115l1.98-14.79a1.5 1.5 0 0 0-.991-1.86zM8.57 12.11l7.82-5.224c.238-.158.467.168.268.365l-6.24 6.162a1.503 1.503 0 0 0-.385.666l-.62 2.383c-.06.23-.38.249-.475.027l-1.14-2.633a1.5 1.5 0 0 1 .772-1.746z"
                    />
                  </svg>
                </a>

              </div>



              <div style={{ display: "flex", background: "black",borderRadius: 22.5, width: 45, height: 45,justifyContent: "center", alignItems: "center" }}>
                <a
                  href="https://x.com/stabolut"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="store-badge"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    fill="white"
                  >
                    <path
                      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                    />
                  </svg>
                </a>

              </div>



              <div style={{ display: "flex", background: "black", borderRadius: 22.5, width: 45, height: 45, justifyContent: "center", alignItems: "center" }}>
                <a
                  href="https://warpcast.com/stabolut"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="store-badge"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    fill="white"
                  >
                    <path
                      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm0 2c3.313 0 6 2.687 6 6s-2.687 6-6 6-6-2.687-6-6 2.687-6 6-6zm0 2c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4z"
                    />
                  </svg>
                </a>

              </div>



              <div style={{ display: "flex", background: "black",borderRadius: 22.5, width: 45, height: 45, justifyContent: "center", alignItems: "center" }}>
                <a
                  href="https://www.linkedin.com/company/stabolut/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="store-badge"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    fill="white"
                  >
                    <path
                      d="M19 0H5a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5zM8 19H5V8h3v11zM6.5 6.732c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zM20 19h-3v-5.604c0-3.368-4-3.113-4 0V19h-3V8h3v1.765c1.396-2.586 7-2.777 7 2.476V19z"
                    />
                  </svg>
                </a>

              </div>


            </div>



            
          </div>
        </div>
        <hr />
        <div className="d-flex align-items-center flex-wrap flex-md-wrap justify-content-between">
          <p
            style={{
              color: "#7E8180",
              fontSize: 11.81,
              fontFamily: "Inter",
              fontWeight: "400",

              wordWrap: "break-word",
            }}
          >
            STABOLUT © ALL RIGHTS RESERVED 2025
          </p>
          <p
            style={{
              color: "#7E8180",
              fontSize: 11.81,
              fontFamily: "Inter",
              fontWeight: "400",

              wordWrap: "break-word",
            }}
            className="d-flex align-items-center"
          >
            <Link to="/privacy" className="footer-privacy-link">Privacy Policy</Link>
            <svg
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.86792 4.4292H8.01479V7.24025L3.07094 2.29639L2.46948 2.89784L7.41334 7.8417H4.60229V8.69482H8.86792V4.4292Z"
                fill="#7E8180"
              />
            </svg>
          </p>
        </div>
      </div>
    </footer>
  );
};
